/*
 * -----------------------------------------------------------------------------------------
 * application.ts
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 13.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 28.11.2022
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import { Customer } from "models/customers";
import { Action, Reducer } from "redux";

export type SET_AUTHENTICATION_TYPE = "application/SET_AUTHENTICATION";
export const SET_AUTHENTICATION: SET_AUTHENTICATION_TYPE = "application/SET_AUTHENTICATION";

export type INITIALIZE_REQUEST_TYPE = "application/INITIALIZE_REQUEST";
export const INITIALIZE_REQUEST: INITIALIZE_REQUEST_TYPE = "application/INITIALIZE_REQUEST";

export type INITIALIZE_SUCCESS_TYPE = "application/INITIALIZE_SUCCESS";
export const INITIALIZE_SUCCESS: INITIALIZE_SUCCESS_TYPE = "application/INITIALIZE_SUCCESS";

export type INITIALIZE_FAILURE_TYPE = "application/INITIALIZE_FAILURE";
export const INITIALIZE_FAILURE: INITIALIZE_FAILURE_TYPE = "application/INITIALIZE_FAILURE";

export type DEBUG_ACTION_TYPE = "application/DEBUG_ACTION";
export const DEBUG_ACTION: DEBUG_ACTION_TYPE = "application/DEBUG_ACTION";

export type SET_VIEW_TYPE = "view/SET_VIEW";
export const SET_VIEW: SET_VIEW_TYPE = "view/SET_VIEW";

export type SET_CUSTOMERS_TYPE = "customers/SET_CUSTOMERS";
export const SET_CUSTOMERS: SET_CUSTOMERS_TYPE = "customers/SET_CUSTOMERS";


export interface InitializeRequestAction extends Action {
  type: INITIALIZE_REQUEST_TYPE;
}

export interface SetAuthenticationAction extends Action {
  type: SET_AUTHENTICATION_TYPE;
  authentication: AuthenticationResponse | null;
}

export interface InitializeSuccessAction extends Action {
  type: INITIALIZE_SUCCESS_TYPE;
}

export interface InitializeFailureAction extends Action {
  type: INITIALIZE_FAILURE_TYPE;
  error: string;
}

export interface DebugAction extends Action {
  type: DEBUG_ACTION_TYPE;
  debug: boolean;
}
export interface SetViewAction extends Action {
  type: SET_VIEW_TYPE;
  view: ViewType | null;
}


export interface SetCustomersAction extends Action {
    type: SET_CUSTOMERS_TYPE;
    customers: Customer[] | [] ;

}


export type ApplicationAction =
  InitializeRequestAction |
  InitializeSuccessAction |
  InitializeFailureAction |
  DebugAction |
  SetAuthenticationAction |
  SetViewAction |
  SetCustomersAction;

export type AuthenticationResponse = {

  refreshToken: string,
  user: string,
  roles: ("ROLE_USER" | "ROLE_ADMIN")[],
  accessToken: string,
  tokenType: string
};
export enum ViewType {
  MAIN,
  LICENCE,
  EDITLICENCE,
  LICENCEADMINISTRATION,
  CUSTOMERSYSTEM,
  SYSTEMLICENCE,
  CUSTOMER,
  CUSTOMERADMINISTRATION,
  CLIENT,
  ADDCUSTSYST,
  MAILSETTINGS,
  CUSTOMERSETTER
}
export type ApplicationState = {
  error: string | null;
  debug: boolean;
  authentication: AuthenticationResponse | null;
  view: ViewType | null;
  customers: Customer [] | null;
};
const initialState: ApplicationState = {
  view: null,
  authentication: null,
  error: null,
  debug: false,
  customers: []
};

export const applicationReducer: Reducer<ApplicationState> =
  (state: ApplicationState = initialState, action: ApplicationAction) => {
    switch (action.type) {
      case INITIALIZE_REQUEST:
        return {
          ...state,
          error: null
        };
      case INITIALIZE_SUCCESS:
        return {
          ...state,
          error: null
        };
      case INITIALIZE_FAILURE:
        return {
          ...state,
          error: action.error
        };
      case DEBUG_ACTION:
        return {
          ...state,
          debug: action.debug
        };
      case SET_AUTHENTICATION:
        return {
          ...state,
          authentication: action.authentication
        };
      case SET_VIEW:
        return {
          ...state,
          view: action.view
        };
      default:
        return state;
    }
  };

export function initializeRequest(): InitializeRequestAction {
  return {
    type: INITIALIZE_REQUEST
  };
}
export function setAuthentication(authentication: AuthenticationResponse | null): SetAuthenticationAction {
  return {
    type: SET_AUTHENTICATION, authentication
  };
}
export function setView(view: ViewType | null): SetViewAction {
  return {
    type: SET_VIEW, view
  };
}

export function setCustomers(customers: Customer [] | []): SetCustomersAction {
    return {
        type: SET_CUSTOMERS, customers
    };
}

export function initializeSuccess(): InitializeSuccessAction {
  return {
    type: INITIALIZE_SUCCESS
  };
}

export function initializeFailure(error): InitializeFailureAction {
  return {
    type: INITIALIZE_FAILURE,
    error
  };
}

export function setDebug(debug: boolean): DebugAction {
  return {
    type: DEBUG_ACTION,
    debug
  };
}
